import React, { useEffect, useState } from "react"
import data from "../../../data.json"
import { Link } from "react-router-dom"
import Header from "../../navigation/Header"
import SearchBar from "../../navigation/SearchBar"
import axios from "axios"
import GetCSFR from "../../../hooks/userAuthentication/GetCSFR"
import { UserContext } from "../../../hooks/images/RetrieveImageContext"
import Carousel from "./Carousel"
import HeroSkeleton from "./HeroSkeleton"
import AcceleratorPartners from "./AcceleratorPartners"

interface ViewProps {
    view: 'mobile' | 'desktop'
}

export default function HeroSection({view}:ViewProps){
    const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false)
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false)
    const csrfToken = GetCSFR({ name: "csrftoken" })
    const [userEmail, setUserEmail] = useState<string>("")
    
    useEffect(()=>{
        // checks if user is currently logged in, determines if viewing coach profiles is allowed or not
        axios.get(`${process.env.REACT_APP_SKILLJA_URL}/auth_status/`, {
            headers: {
                'X-CSRFToken': csrfToken,
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
        .then(res => {
            if (res.status === 200) {
                setIsLoggedIn(res.data.is_logged_in)
                setUserEmail(res.data.email)
            } else {
                console.error("Failed to verify authentication")
            }
        })
        .catch(error => {
            console.error("Error checking authentication", error)
        })
    },[])

    // Load skeleton until hero section loads
    useEffect(() => {
        if (document.readyState === "complete") {
            setIsPageLoaded(true)
        } else {
            const handleLoad = () => {
                setIsPageLoaded(true)
            }
            window.addEventListener('load', handleLoad)
            return () => window.removeEventListener('load', handleLoad)
        }
    }, [])
    

    return (
        <>
        {view === 'mobile' ? (
            isPageLoaded ?
                <div className={`md:mb-28 bg-main-cream flex flex-col justify-start items-center px-2`}>
                    {(userEmail && isLoggedIn) && ( 
                        <UserContext.Provider value={{imageName:userEmail, cache:true}}>
                            <Header useCase="protected" /> 
                        </UserContext.Provider>
                    )}
                    { (!userEmail || !isLoggedIn) && ( <Header useCase="default" /> ) }
                    <h1 className="text-center text-main-green-900 font-semibold text-4xl px-4 font-kulim mb-10">
                        {data.landing.hero.title.slice(0,-1)}
                    </h1>
                    <SearchBar mobileView={true} queryPage={1}/>
                    <img 
                        src={require('../../../assets/landingAssets/main-landing-racers.png')} 
                        className="w-64 mt-6 mb-5 lg:w-80"
                        alt="two runners kneeling down ready to race each other"
                    />
                    <div className="mb-10">
                        <Carousel displaySize="small" />
                    </div>
                    <Link 
                        to={'/signup'} 
                        className="flex flex-col justify-center mx-auto w-80 md:w-6/12 mt-7 mb-7"
                    >
                        <button 
                            className="form-btn"
                            aria-label="create an account button that redirects to sign up page"
                        >
                            Create an Account
                        </button>
                    </Link>
                    <p className="text-main-grey-300 font-kulim">
                        Already have an account? 
                        <Link to={'/login'}>
                            <span className="underline text-main-green-700 ml-2">Login Here</span>
                        </Link>
                    </p>
                    <AcceleratorPartners />
                </div>
            :
                <HeroSkeleton view={view} />
        )
        :
        (
            isPageLoaded ?
                <div className={`bg-main-cream flex flex-col justify-start items-center`}>
                    { (userEmail && isLoggedIn) && ( 
                        <UserContext.Provider value={{imageName:userEmail, cache:true}}>
                            <Header useCase="protected" /> 
                        </UserContext.Provider>
                    )}
                    { (!userEmail || !isLoggedIn) && ( <Header useCase="default" /> ) }
                    <h1 className="text-center text-main-green-900 font-semibold text-4xl px-4 font-kulim mb-1">
                        {data.landing.hero.title.slice(0,-1)},
                    </h1>
                    <h1 className="text-center text-main-green-900 font-semibold text-4xl px-4 font-kulim mb-1.5">
                        anytime, anywhere.
                    </h1>
                    <SearchBar mobileView={false} queryPage={1} />
                    <img 
                        src={require('../../../assets/landingAssets/main-landing-racers.png')} 
                        className="w-80 mt-6 mb-5"
                        alt="two runners kneeling down ready to race each other"
                    />
                    <Carousel displaySize="large"/>
                    <AcceleratorPartners />
                </div>
            :
                <HeroSkeleton view={view} />

        )}
        </> 
    )
} 

